import axios from 'axios';

const getTableauToken = async () => {
  const { data } = await axios.get<{ token: string }>('/tableau/jwt');
  return data;
};

export default getTableauToken;
